export const SETTINGS_CHAIN_EDITED_EVENT = 'settings-chain-edited';
export const SETTINGS_VALUE_DELETED_EVENT = 'settings-value-deleted';
export const SETTINGS_OVERRIDE_EVENT = 'settings-override';